function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.00065 13.5543C11.0689 13.5543 13.5562 11.0669 13.5562 7.9987C13.5562 4.93045 11.0689 2.44314 8.00065 2.44314C4.9324 2.44314 2.4451 4.93045 2.4451 7.9987C2.4451 11.0669 4.9324 13.5543 8.00065 13.5543ZM8.00065 14.6654C11.6825 14.6654 14.6673 11.6806 14.6673 7.9987C14.6673 4.3168 11.6825 1.33203 8.00065 1.33203C4.31875 1.33203 1.33398 4.3168 1.33398 7.9987C1.33398 11.6806 4.31875 14.6654 8.00065 14.6654Z",
  fill: "#FF8D10"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.23333 9.89019C7.23333 9.61612 7.28889 9.37167 7.4 9.15686C7.51852 8.94204 7.65556 8.76427 7.81111 8.62352C7.96667 8.47538 8.18518 8.28649 8.46667 8.05686C8.74815 7.82723 8.95926 7.61982 9.1 7.43464C9.24074 7.24945 9.31111 7.03464 9.31111 6.79019C9.31111 6.3976 9.19259 6.11982 8.95556 5.95686C8.72593 5.78649 8.32593 5.7013 7.75556 5.7013C7.45926 5.7013 7.15185 5.73834 6.83333 5.81241C6.52222 5.88649 6.24444 5.98278 6 6.1013V5.07908C6.25926 4.95315 6.56667 4.85315 6.92222 4.77908C7.28518 4.70501 7.66667 4.66797 8.06667 4.66797C8.86667 4.66797 9.47778 4.84575 9.9 5.2013C10.3222 5.55686 10.5333 6.05686 10.5333 6.7013C10.5333 7.08649 10.4481 7.40501 10.2778 7.65686C10.1074 7.9013 9.83333 8.17908 9.45555 8.49019C9.4037 8.53464 9.26667 8.64945 9.04444 8.83464C8.82222 9.01241 8.66667 9.19019 8.57778 9.36797C8.48889 9.53834 8.44444 9.73093 8.44444 9.94575V10.1346H7.23333V9.89019ZM7.18889 11.0235H8.47778V11.9346H7.18889V11.0235Z",
  fill: "#FF8D10"
});

const SvgHint = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHint, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hint.15aace91.svg";
export { ForwardRef as ReactComponent };